// material
import { styled } from "@mui/material/styles";
import { Card, Skeleton, Typography } from "@mui/material";
// utils
import { fShortenNumber } from "../../../Utils/formatNumber";
//
import Iconify from "../../../Components/Dashboard/Iconify";
import { useSelector } from "react-redux";
const getState = (state) => state.skillsReducer;
// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: "none",
  textAlign: "center",
  padding: theme.spacing(3, 0),
  color: theme.palette.warning.darker,
  backgroundColor: "#FFF4DE",
  borderRadius: "16px",
}));

const IconWrapperStyle = styled("div")(({ theme }) => ({
  margin: "auto",
  display: "flex",
  borderRadius: "50%",
  alignItems: "center",
  width: theme.spacing(5),
  height: theme.spacing(5),
  justifyContent: "center",
  marginBottom: theme.spacing(2),
  color: "#FFF",
  backgroundColor: "#FF947A",
}));

// ----------------------------------------------------------------------

export default function CardAllSubSkills() {
  const { totalSkillSetData } = useSelector(getState);
  const TOTAL = totalSkillSetData.totalSubSkills;
  return (
    <>
      {Object.keys(totalSkillSetData).length === 0 ? (
        <Skeleton variant="rounded" width="212px" height="156px" />
      ) : (
        <RootStyle>
          <IconWrapperStyle>
            <Iconify icon="mdi:star-cog" width={22} height={22} />
          </IconWrapperStyle>
          <Typography variant="h5" fontWeight={700} fontSize={"25px"}>
            {fShortenNumber(TOTAL)}
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ opacity: 0.72, fontSize: "12px" }}
          >
            Sub Skills
          </Typography>
        </RootStyle>
      )}
    </>
  );
}
